import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	resultLabel: {
		id: 'search-branch-result.label',
		defaultMessage: 'Branch',
		description: 'Search branch label',
	},
});
